const styles = {
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '14px',
        lineHeight: '21px',
        color: '#001533',
        paddingLeft: '16px',
        fontWeight: '600',
        textTransform: 'capitalize',
        cursor: 'pointer',
        flex: 1,
    },
    userTitle: {
        fontFamily: 'Silka_Medium',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#4D5C71',
        paddingLeft: '16px',
        fontWeight: '500',
        textTransform: 'capitalize',
    },
    rowLabel: {
        fontFamily: 'Silka_Regular',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '400',
        color: '#4D5C71',
        paddingLeft: '10px',
        cursor: 'pointer',
    },
    email: {
        display: 'flex',
        alignItems: 'center',
    },
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '48px',
    },
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '598px',
        height: '48px',
        margin: '0px 24px',
    },
    countText: (size: number, radius: string, fontSize: number, bgColor?: string) => ({
        fontFamily: 'Silka_Bold',
        color: bgColor === '#E0E4ED' ? '#5C697B' : '#FFFFFF',
        backgroundColor: bgColor || '#8697AB',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        height: size,
        width: size,
        borderRadius: radius,
        display: 'flex',
        fontWeight: 700,
        fontSize,
        textTransform: 'uppercase',
        marginLeft: '-7Px',
        position: 'relative',
    }),
    confirm: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
    },
    cancel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderWidth: '2px',
    },
    active: {
        width: '37px',
        height: '18px',
        padding: '4px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        background: 'rgba(23, 137, 0, 0.1)',
        borderRadius: '40px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: '500',
        fontSize: '12px',
        color: '#178900',
    },
    inActive: {
        width: '48px',
        height: '18px',
        padding: '4px 8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        background: 'rgba(237, 0, 0, 0.1)',
        borderRadius: '40px',
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: '500',
        fontSize: '12px',
        color: '#ED0000',
    },
    dateText: {
        fontFamily: 'Silka_Medium',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#4D5C71',
        fontWeight: '500',
    },
};
export default styles;
